import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import * as React from 'react'
import { useIntl } from 'react-intl'

type Props = {
  invoice: IInvoice
}

const getColor = (status: IInvoiceStatus): string => {
  switch (status) {
    case 'paid':
      return 'default'
    case 'unpaid':
      return 'success'
    case 'other':
      return 'default'
    case 'due':
      return 'error'
  }
}

const InvoiceStatus: React.FC<Props> = ({ invoice }) => {
  const { formatMessage } = useIntl()
  const status = invoice.status || 'other'

  if (invoice.__typename === 'Invoice') {
    return <KTag color={getColor(status)} text={formatMessage({ id: status })} />
  }

  return null
}

export default InvoiceStatus
